import React from "react";
import { StoresTemplate } from "../../Templates/StoresTemplate";

export const Stores = () => {
  return <StoresTemplate />;
};
